/**
 * 選択されたformIDを格納する
 */
const selectedFormIds = {
  namespaced: true,
  state: {
    bigan_name: "",
    lists: {
      brand_names: [],
      worries_some: [],
      price_range: [],
      seibun: [],
      kinou_search: [],
    },
  },
  mutations: {
    setCheckboxValue(state, payload) {
      const lists = state.lists;
      const { target, value } = payload;
      if (lists[target]) lists[target] = value;
    },
    setRadioValue(state, payload) {
      const { target, value } = payload;
      if (state[target] !== undefined) state[target] = value;
    },
  },
  actions: {
    setCheckboxValue: ({ commit }, payload) => {
      commit("setCheckboxValue", payload);
    },
    setRadioValue: ({ commit }, payload) => {
      commit("setRadioValue", payload);
    },
  },
  getters: {
    selectedLists(state) {
      return state.lists;
    },
    selectedCategory(state) {
      return state.bigan_name;
    },
    isCategorySelected(state) {
      return state.bigan_name !== "";
    },
    isListChecked(state) {
      const allSelectedArray = Object.values(state.lists).flat();
      const isChecked = allSelectedArray.length !== 0;
      return isChecked;
    },
  },
};

export default selectedFormIds;
